export default "__VITE_ASSET__7ebc3b9b__"